import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, CheckCircle2, Package, Check, Star } from 'lucide-react';
import { PLANS, DEFAULT_PLAN, type PlanId } from '../lib/checkout';
export function FinalCta() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>(DEFAULT_PLAN);
  const activePlan = PLANS[selectedPlan];
  const handleCheckout = () => {
    window.location.href = activePlan.checkoutUrl;
  };
  return <section className="py-10 md:py-[60px] px-5 bg-gradient-to-br from-navy to-blue text-white text-center" data-id="element-32">
      <div className="max-w-[700px] mx-auto" data-id="element-33">
        <h2 className="font-display text-[clamp(28px,7vw,56px)] mb-3 md:mb-4 leading-tight" data-id="element-34">
          No dejes pasar esta oportunidad.
          <br data-id="element-35" />
          <span className="text-gold" data-id="element-36">
            El precio sube cuando termina el contador.
          </span>
        </h2>
        <p className="text-[14px] md:text-[17px] opacity-80 max-w-[560px] mx-auto mb-6 md:mb-8" data-id="element-37">
          Cada día que pasan sin esta información es un día más en que las
          instituciones juegan con ventaja. Eso cambia hoy.
        </p>

        {/* HORIZONTAL ROW PLAN SELECTOR */}
        <div className="space-y-3 mb-5" data-id="element-38">
          {(['total', 'basic'] as PlanId[]).map(planId => {
          const plan = PLANS[planId];
          const isSelected = selectedPlan === planId;
          const isFeatured = plan.featured;
          return <motion.button key={planId} onClick={() => setSelectedPlan(planId)} whileTap={{
            scale: 0.99
          }} whileHover={{
            x: 2
          }} className={`relative w-full text-left rounded-2xl overflow-hidden transition-all duration-200 border-2 ${isSelected ? isFeatured ? 'bg-white/15 border-gold shadow-gold-glow' : 'bg-white/15 border-white shadow-lg' : 'bg-white/5 border-white/20 opacity-75 hover:opacity-100'}`} data-id="element-39">
                {isFeatured && <div className="bg-gold text-navy text-center py-1 text-[10px] md:text-[11px] font-extrabold tracking-[0.08em] flex items-center justify-center gap-1.5" data-id="element-40">
                    <Star size={11} fill="currentColor" data-id="element-41" /> MÁS ELEGIDO
                  </div>}

                <div className="flex items-center gap-3 md:gap-4 p-3.5 md:p-5" data-id="element-42">
                  {/* Radio indicator */}
                  <div className="flex-shrink-0" data-id="element-43">
                    <div className={`w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? isFeatured ? 'bg-gold border-gold' : 'bg-white border-white' : 'border-white/40 bg-transparent'}`} data-id="element-44">
                      {isSelected && <Check size={14} className="text-navy" strokeWidth={3} data-id="element-45" />}
                    </div>
                  </div>

                  {/* Plan info */}
                  <div className="flex-1 min-w-0 text-left" data-id="element-46">
                    <div className="font-display text-[18px] md:text-[24px] text-white leading-tight" data-id="element-47">
                      {plan.name}
                    </div>
                    <div className="text-[11px] md:text-[13px] opacity-60 leading-snug mt-0.5" data-id="element-48">
                      {plan.tagline}
                    </div>
                  </div>

                  {/* Prices */}
                  <div className="flex-shrink-0 text-right" data-id="element-49">
                    <div className="text-[11px] md:text-[13px] opacity-50 line-through leading-none" data-id="element-50">
                      {plan.oldPrice}
                    </div>
                    <div className={`font-display text-[26px] md:text-[38px] leading-none mt-0.5 ${isFeatured ? 'text-gold' : 'text-gold-light'}`} data-id="element-51">
                      {plan.price}
                    </div>
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        {/* SHARED CTA BUTTON */}
        <motion.button onClick={handleCheckout} whileTap={{
        scale: 0.98
      }} animate={selectedPlan === 'total' ? {
        boxShadow: ['0 6px 30px rgba(201,168,76,0.4)', '0 6px 50px rgba(201,168,76,0.65)', '0 6px 30px rgba(201,168,76,0.4)']
      } : {}} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className={`w-full block text-center font-display text-[18px] md:text-[22px] tracking-wide py-4 md:py-5 rounded-xl transition-all hover:-translate-y-0.5 ${selectedPlan === 'total' ? 'bg-gold text-navy' : 'bg-white text-navy shadow-lg'}`} data-id="element-52">
          💥 COMPRAR {activePlan.name} — {activePlan.price}
        </motion.button>

        <p className="text-center text-[12px] md:text-[13px] opacity-70 mt-3" data-id="element-53">
          Pago único · Acceso inmediato · Garantía total 7 días
        </p>

        <div className="flex justify-center gap-3 md:gap-6 flex-wrap mt-5 md:mt-6 opacity-70 text-[11px] md:text-[13px]" data-id="element-54">
          <span className="flex items-center gap-1.5" data-id="element-55">
            <Shield size={14} data-id="element-56" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-57">
            <Zap size={14} data-id="element-58" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-59">
            <CheckCircle2 size={14} data-id="element-60" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-61">
            <Package size={14} data-id="element-62" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}